// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"48c67178","239":"2a1de65f","455":"d146383b","977":"6662d332"}[chunkId] + ".chunk.js";
};